import React from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
/*

*/
const CartPaymentInfo = ({
  className,
  icons
}: {
  className?: string
  icons?: React.ReactNode
}) => {
  const { formatMessage } = useIntl()
  const {
    theme: {
      font: { regular: fontRegular }
    }
  } = useConfig()

  return (
    <div className={`${className ? className : ''} mb-4 flex flex-col`}>
      <span
        className={`${fontRegular} text-14 tracking-0  text-grayRegular py-2`}
      >
        {formatMessage({
          id: 'msp.cart.payment.info',
          defaultMessage: 'Pay with'
        })}
      </span>
      <div className='flex space-x-2'>{icons}</div>
    </div>
  )
}

export default CartPaymentInfo
